import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {DatePickerModule} from "@syncfusion/ej2-angular-calendars";


@Component({
    selector: 'app-form-date',
    imports: [
        DatePickerModule,
        ReactiveFormsModule
    ],
    templateUrl: './form-date.component.html',
    styleUrl: './form-date.component.scss'
})
export class FormDateComponent implements OnChanges {

  @Input() public fCN: string = '';
  @Input() public disabled: boolean = false;
  @Input() public cssClass: string = '';
  @Input() public placeholder: string = '';
  @Input() public onlyDisplayIcon: boolean = false;
  @Input() public notBefore: Date | null = null;
  @Input() public notAfter: Date | null = null;
  @Input() public showClearButton: boolean = false;
  @Input() public fG: FormGroup = new FormGroup({});

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled'] && this.fG.controls[this.fCN]) {
      if (this.disabled) {
        this.fG.controls[this.fCN].disable();
      } else {
        this.fG.controls[this.fCN].enable();
      }
    }
  }
}
